import { featureFlags } from "#/config/featureFlags";

import { useFeatureFlags } from "./useFeatureFlags";

export const useOneClickTradingFeatureFlag = () => {
  const isOneClickTradingDisabled = useFeatureFlags<boolean>(
    featureFlags.disableOneClickTrading,
  );

  return {
    isEnabled: !isOneClickTradingDisabled,
  };
};
